<template>
<loader v-bind="{ loading }">
  <h3 class="title">Create Secondary Scraper</h3>
  <h4 class="title is-4">
    {{ scraper.scraper.name }}
  </h4>
  <div class="columns">
    <div class="column">
      {{ scraper.scraper.description }}
    </div>
  </div>
  
  <div class="columns">
    <div class="column">
      <div class="code-string">
        {{ scraper.payload }}
      </div>
      <p class="is-flex">
        {{ scraper.scraper.return_value }} <icon icon="level-up-alt" class="fa-rotate-90"/> 
      </p>
    </div>
  </div>

  <secondary-scraper-builder 
    :scraper="scraper"
    :scraper-types="secondary_scraper_types"
  />
</loader>  
</template>
<script>
import { loadSecondaryScraperTypes, loadAttributeScraper } from '@/api/super'
import SecondaryScraperBuilder from './Builder'
export default {

  components: {
    SecondaryScraperBuilder
  },
  
  data: () => ({
    loading: true,
    scraper: {
      scraper: {}
    },
    secondary_scraper_types: []
  }),

  beforeCreate() {
    Promise.all([
      loadSecondaryScraperTypes(this.$route.params.attributeType, ({data}) => this.secondary_scraper_types = data),
      loadAttributeScraper(this.$route.params.scraper, ({data}) => this.scraper = data),
    ]).finally(() => this.loading = false)
  }

}
</script>